export default class api {
  static apiConfig = {
    //baseUrl: 'http://8.129.173.32:8019/api',
    // 测试服
    //baseUrl:'http://apitest.haiouchat.com',
    // 正式服
     baseUrl: 'https://api.haiouchat.com/api',
    // 通过密码登陆
    uploadUrl: '/sysUser/login',
    login: '/sysUser/login',

    //获取页面数据
    getAwards: '/awards',

    getPrizeUser: '/awards/prize/user',

    doAwards: '/awards/raffle',
    


  };
}



// WEBPACK FOOTER //
// ./src/api/api.js